import { RootState } from "../../rootReducer";

export const selectIsUpdatingReleaseDate = (state: RootState) =>
  state.updateReleaseDate.loading;
export const updateReleaseDateErrorMessage = (state: RootState) =>
  state.updateReleaseDate.error;
export const updateReleaseDateResponse = (state: RootState) =>
  state.updateReleaseDate.updateReleaseDateResponse;
